import React from "react";
import "./WhyChooseMbr.css";
import GroupsIcon from "@mui/icons-material/Groups";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import WorkspacePremiumIcon from "@mui/icons-material/WorkspacePremium";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";
import EmojiPeopleIcon from "@mui/icons-material/EmojiPeople";
import CodeIcon from "@mui/icons-material/Code";
import SmartphoneIcon from "@mui/icons-material/Smartphone";


const WhyChooseMbr = () => {
  const highlights = [
    {
      icon: <BusinessCenterIcon className="why-icon" />,
      title: "Trusted by 100+ Companies",
      desc: "We’ve partnered with reputed organizations to connect students directly with real job opportunities.",
      color: "linear-gradient(135deg, #00c6ff, #0072ff)",
    },
    {
      icon: <GroupsIcon className="why-icon" />,
      title: "Global HR Network (10,000+ Connections)",
      desc: "Strong professional ties with HRs around the globe helping you land the right job faster.",
      color: "linear-gradient(135deg, #43e97b, #38f9d7)",
    },
    {
      icon: <LinkedInIcon className="why-icon" />,
      title: "LinkedIn Optimization Experts",
      desc: "We turn your LinkedIn profile into a career magnet that attracts recruiters instantly.",
      color: "linear-gradient(135deg, #f7971e, #ffd200)",
    },
    {
      icon: <CodeIcon className="why-icon" />,
      title: "Experts in Web Development",
      desc: "Our experienced developers craft fast, responsive, and secure web applications that deliver real business value.",
      color: "linear-gradient(135deg, #00b09b, #96c93d)",
    },
    {
      icon: <SmartphoneIcon className="why-icon" />,
      title: "Mobile App Development Professionals",
      desc: "We build high-performance mobile apps with modern UI and robust backend for both Android & iOS — faster, better, smarter.",
      color: "linear-gradient(135deg, #fc466b, #3f5efb)",
    },
    {
      icon: <WorkspacePremiumIcon className="why-icon" />,
      title: "Real-Time Experienced Mentors",
      desc: "Our mentors from top IT firms bring practical knowledge and live interview experience.",
      color: "linear-gradient(135deg, #a18cd1, #fbc2eb)",
    },
    {
      icon: <SupportAgentIcon className="why-icon" />,
      title: "Free Consultation for Freshers",
      desc: "We guide every fresher personally to shape a career path that suits their goals perfectly.",
      color: "linear-gradient(135deg, #ff0844, #ffb199)",
    },
    {
      icon: <EmojiPeopleIcon className="why-icon" />,
      title: "Always Here to Help You",
      desc: "We’re always available for any doubts or support — because your growth is our mission.",
      color: "linear-gradient(135deg, #f5af19, #f12711)",
    },
  ];

  return (
    <section className="why-section">
      <div className="why-header">
        <h2>
          Why Choose <span>MBR Network’s</span>
        </h2>
        <p>
          Here’s what makes us stand out from the rest — trusted guidance, real
          connections, and unmatched dedication.
        </p>
      </div>

      <div className="why-grid">
        {highlights.map((item, index) => (
          <div
            key={index}
            className="why-card"
            style={{ background: item.color }}
          >
            <div className="why-card-inner">
              {item.icon}
              <h3 className="why-title">{item.title}</h3>
              <p className="why-desc">{item.desc}</p>
            </div>
          </div>
        ))}
      </div>

      <div className="why-tagline">
        <p>✨ MBR Network’s — Where Guidance Meets Guaranteed Growth ✨</p>
      </div>
    </section>
  );
};

export default WhyChooseMbr;
